import { Chip, ChipProps } from "@progress/kendo-react-buttons";

function DisableableChiplistChip(props: ChipProps) {
  const { dataItem: { disabled } } = props;

  return (
    <Chip
      {...props}
      size={props.size ?? "medium"}
      rounded={props.rounded ?? "medium"}
      fillMode={props.fillMode ?? "outline"}
      themeColor={props.themeColor ?? "base"}
      disabled={disabled}
    />
  );
}

export default DisableableChiplistChip;
